export const GAMMA_PRIME_YOUTUBE_URL = 'https://www.youtube.com/@GammaPrime_com';
export const GAMMA_PRIME_X_URL = 'https://x.com/GammaPrime';
export const GAMMA_PRIME_LINKEDIN_URL = 'https://www.linkedin.com/company/gamma-prime-defi/';
export const GAMMA_PRIME_EMAIL = 'mailto:info@gammaprime.com';
